/**
 * PJAX Navigation - Mein Konto Sidebar
 *
 * Fetch + DOM-Swap fuer Sidebar-Navigation ohne Seiten-Reload.
 * Progressive Enhancement: Ohne JS funktionieren Links normal.
 *
 * Eager Preloading: Alle Sektionen werden beim Seitenaufruf vorgeladen,
 * sodass Klicks sofort (ohne Netzwerk-Request) umschalten.
 *
 * @package Brandner_Custom
 * @since 2.1.0
 */
(function($) {
    'use strict';

    var PJAX = {
        cache: {},
        contentCache: {},  // Pre-parsed innerHTML cache
        inFlight: {},      // In-flight fetch promises (prevents duplicate requests)
        CACHE_TTL: 300000, // 5 Minuten
        currentSection: null,
        isNavigating: false,

        /**
         * Initialize PJAX navigation
         */
        init: function() {
            var $nav = $('.woocommerce-MyAccount-navigation');
            var $content = $('.woocommerce-MyAccount-content');
            if (!$nav.length || !$content.length) return;

            this.$nav = $nav;
            this.$content = $content;
            this.currentSection = this.getSectionFromUrl(window.location.href);

            // Cache current page content immediately
            this.cacheCurrentContent();

            this.bindSidebarLinks();
            this.bindPopstate();
            this.bindHoverPreload();

            // Mark initial state in history
            if (!history.state || !history.state.pjax) {
                history.replaceState(
                    { pjax: true, url: window.location.href },
                    '',
                    window.location.href
                );
            }

            // Eager preload all sidebar links during idle time
            this.eagerPreload();
        },

        /**
         * Cache the current page's content (for instant back-navigation)
         */
        cacheCurrentContent: function() {
            var url = window.location.href;
            var html = this.$content.html();
            if (html) {
                this.contentCache[url] = { html: html, time: Date.now() };
            }
        },

        /**
         * Eager preload: fetch ALL sidebar links in parallel
         */
        eagerPreload: function() {
            var self = this;

            this.$nav.find('a').each(function() {
                var $link = $(this);
                var $li = $link.closest('li');
                var href = $link.attr('href');

                // Skip logout link and current page
                if ($li.hasClass('woocommerce-MyAccount-navigation-link--customer-logout')) return;
                if (self.getSectionFromUrl(href) === self.currentSection) return;

                // Skip if already cached
                if (self.contentCache[href] && (Date.now() - self.contentCache[href].time) < self.CACHE_TTL) return;

                // Fire all fetches immediately in parallel
                self.fetchAndCache(href);
            });
        },

        /**
         * Fetch page and cache both raw HTML and extracted content.
         * Reuses in-flight promises to avoid duplicate requests.
         */
        fetchAndCache: function(url) {
            var self = this;

            // Already have parsed content cached?
            var cached = this.contentCache[url];
            if (cached && (Date.now() - cached.time) < this.CACHE_TTL) {
                return Promise.resolve(cached.html);
            }

            // Already fetching this URL? Reuse the in-flight promise
            if (this.inFlight[url]) {
                return this.inFlight[url];
            }

            var promise = fetch(url, {
                credentials: 'same-origin',
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            }).then(function(response) {
                if (!response.ok) return null;
                return response.text();
            }).then(function(html) {
                if (html) {
                    // Cache raw HTML
                    self.cache[url] = { html: html, time: Date.now() };
                    // Pre-parse and cache extracted content
                    var content = self.extractContent(html);
                    if (content) {
                        self.contentCache[url] = { html: content, time: Date.now() };
                    }
                    return content;
                }
                return null;
            }).catch(function() {
                return null;
            }).then(function(result) {
                delete self.inFlight[url];
                return result;
            });

            this.inFlight[url] = promise;
            return promise;
        },

        /**
         * Bind click handler on sidebar links
         */
        bindSidebarLinks: function() {
            var self = this;

            this.$nav.on('click', 'a', function(e) {
                var $link = $(this);
                var href = $link.attr('href');
                var $li = $link.closest('li');

                // Abmelden-Link: normaler Klick
                if ($li.hasClass('woocommerce-MyAccount-navigation-link--customer-logout')) {
                    return;
                }

                // Modifier keys: normaler Klick (neuer Tab etc.)
                if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
                    return;
                }

                // Gleiche Sektion: nichts tun
                var targetSection = self.getSectionFromUrl(href);
                if (targetSection === self.currentSection && !self.isNavigating) {
                    e.preventDefault();
                    return;
                }

                e.preventDefault();
                self.navigateTo(href, targetSection);
            });
        },

        /**
         * Handle browser back/forward
         */
        bindPopstate: function() {
            var self = this;

            window.addEventListener('popstate', function(e) {
                if (e.state && e.state.pjax && e.state.url) {
                    var section = self.getSectionFromUrl(e.state.url);
                    self.loadContent(e.state.url, section, false);
                }
            });
        },

        /**
         * Preload on hover (instant, no delay)
         */
        bindHoverPreload: function() {
            var self = this;

            this.$nav.on('mouseenter', 'a', function() {
                var $link = $(this);
                var $li = $link.closest('li');
                var href = $link.attr('href');

                // Skip logout link
                if ($li.hasClass('woocommerce-MyAccount-navigation-link--customer-logout')) {
                    return;
                }

                // Instant prefetch (no delay)
                self.fetchAndCache(href);
            });
        },

        /**
         * Navigate to a new section
         */
        navigateTo: function(url, section) {
            if (this.isNavigating) return;

            // Cache current content before leaving
            this.cacheCurrentContent();

            history.pushState({ pjax: true, url: url }, '', url);
            this.loadContent(url, section, true);
        },

        /**
         * Load content and swap
         */
        loadContent: function(url, section, animate) {
            var self = this;
            this.isNavigating = true;

            // Cleanup current section
            this.cleanupSection(this.currentSection);

            // Check if we have cached content for instant swap
            var cached = this.contentCache[url];
            var hasCachedContent = cached && (Date.now() - cached.time) < this.CACHE_TTL;

            if (hasCachedContent) {
                // INSTANT SWAP: no spinner, no fade, no waiting
                self.$content.html(cached.html);
                self.updateSidebarActive(section);
                self.currentSection = section;
                self.isNavigating = false;
                self.initSection(section);

                // Scroll to top only if needed (instant, no animation)
                var contentTop = self.$content.offset().top - 20;
                if ($(window).scrollTop() > contentTop) {
                    window.scrollTo(0, contentTop);
                }
                return;
            }

            // NO CACHE: Show loading state with delayed spinner
            this.$content.addClass('pjax-loading');
            var spinnerTimeout = setTimeout(function() {
                if (!self.$content.find('.pjax-spinner').length) {
                    self.$content.append('<div class="pjax-spinner"></div>');
                }
            }, 150);

            // Update sidebar active state immediately
            this.updateSidebarActive(section);

            // Fetch the page
            this.fetchAndCache(url).then(function(content) {
                clearTimeout(spinnerTimeout);

                if (!content) {
                    // Fetch failed - fallback to normal navigation
                    window.location.href = url;
                    return;
                }

                // Swap content
                self.$content.find('.pjax-spinner').remove();
                self.$content.removeClass('pjax-loading');
                self.$content.html(content);

                if (animate) {
                    self.$content.addClass('pjax-fade-in');
                    setTimeout(function() {
                        self.$content.removeClass('pjax-fade-in');
                    }, 300);
                }

                // Update state
                self.currentSection = section;
                self.isNavigating = false;

                // Init new section
                self.initSection(section);

                // Scroll to top of content if needed
                var contentTop = self.$content.offset().top - 20;
                if ($(window).scrollTop() > contentTop) {
                    $('html, body').animate({ scrollTop: contentTop }, 200);
                }
            }).catch(function() {
                clearTimeout(spinnerTimeout);
                // Error fallback
                window.location.href = url;
            });
        },

        /**
         * Fetch a page (with cache) - kept for backward compatibility
         */
        fetchPage: function(url) {
            var cached = this.cache[url];
            if (cached && (Date.now() - cached.time) < this.CACHE_TTL) {
                return Promise.resolve(cached.html);
            }

            var self = this;
            return fetch(url, {
                credentials: 'same-origin',
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            }).then(function(response) {
                if (!response.ok) return null;
                return response.text();
            }).then(function(html) {
                if (html) {
                    self.cache[url] = { html: html, time: Date.now() };
                }
                return html;
            }).catch(function() {
                return null;
            });
        },

        /**
         * Extract .woocommerce-MyAccount-content innerHTML from fetched page
         */
        extractContent: function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var content = doc.querySelector('.woocommerce-MyAccount-content');
            return content ? content.innerHTML : null;
        },

        /**
         * Determine section name from URL
         */
        getSectionFromUrl: function(url) {
            try {
                var path = new URL(url, window.location.origin).pathname;
                if (path.indexOf('/uwa-auctions') !== -1) return 'uwa-auctions';
                if (path.indexOf('/orders') !== -1) return 'orders';
                if (path.indexOf('/edit-account') !== -1) return 'edit-account';
                // Default (mein-konto root → redirects to edit-account)
                return 'edit-account';
            } catch(e) {
                return 'edit-account';
            }
        },

        /**
         * Update active sidebar item
         */
        updateSidebarActive: function(section) {
            this.$nav.find('li').removeClass('is-active');
            this.$nav.find('.woocommerce-MyAccount-navigation-link--' + section)
                .addClass('is-active');
        },

        /**
         * Cleanup when leaving a section
         */
        cleanupSection: function(section) {
            switch(section) {
                case 'edit-account':
                    if (typeof window.BrandnerProfileDestroy === 'function') {
                        window.BrandnerProfileDestroy();
                    }
                    if (typeof window.BrandnerPlzLookupDestroy === 'function') {
                        window.BrandnerPlzLookupDestroy();
                    }
                    break;

                case 'uwa-auctions':
                    if (typeof window.BrandnerAuctionCenterDestroy === 'function') {
                        window.BrandnerAuctionCenterDestroy();
                    }
                    if (window.BrandnerRealtime && typeof window.BrandnerRealtime.destroy === 'function') {
                        window.BrandnerRealtime.destroy();
                    }
                    break;

                case 'orders':
                    // No cleanup needed
                    break;
            }
        },

        /**
         * Initialize JS for a newly loaded section
         */
        initSection: function(section) {
            switch(section) {
                case 'edit-account':
                    if (typeof window.BrandnerProfileInit === 'function') {
                        window.BrandnerProfileInit();
                    }
                    if (typeof window.BrandnerPlzLookupInit === 'function') {
                        window.BrandnerPlzLookupInit();
                    }
                    break;

                case 'uwa-auctions':
                    if (typeof window.BrandnerAuctionCenterInit === 'function') {
                        window.BrandnerAuctionCenterInit();
                    }
                    // Re-init BrandnerRealtime if auction cards present
                    if (window.BrandnerRealtime && $('.brandner-auction-card-bid').length) {
                        window.BrandnerRealtime.init();
                    }
                    // Re-init auction card timers (inline script from brandner-custom.php)
                    if (typeof window.initAuctionCardTimers === 'function') {
                        window.initAuctionCardTimers();
                    }
                    break;

                case 'orders':
                    // Intercept pagination links within orders
                    this.interceptOrdersPagination();
                    break;
            }
        },

        /**
         * Make orders pagination work via PJAX
         */
        interceptOrdersPagination: function() {
            var self = this;

            this.$content.on('click', '.woocommerce-pagination a, .woocommerce-Pagination a', function(e) {
                if (e.ctrlKey || e.metaKey || e.shiftKey) return;

                e.preventDefault();
                var href = $(this).attr('href');
                history.pushState({ pjax: true, url: href }, '', href);

                // Invalidate cache for orders (pagination changes)
                Object.keys(self.cache).forEach(function(key) {
                    if (key.indexOf('/orders') !== -1) {
                        delete self.cache[key];
                    }
                });
                Object.keys(self.contentCache).forEach(function(key) {
                    if (key.indexOf('/orders') !== -1) {
                        delete self.contentCache[key];
                    }
                });

                self.loadContent(href, 'orders', true);
            });
        },

        /**
         * Invalidate cache (e.g. after form submit)
         */
        invalidateCache: function() {
            this.cache = {};
            this.contentCache = {};
            this.inFlight = {};
        }
    };

    // Initialize on DOM ready
    $(document).ready(function() {
        PJAX.init();
    });

    // Expose for external access
    window.BrandnerPjax = PJAX;

})(jQuery);
